<template>
    <Sections>
        <SectionText
            padding="py-8 sm:py-10"
            heading="Courses"
            color="bg-zinc-100"
        >
            <template v-slot:custom>
                <LayoutSearchBar
                    class="mb-2 mt-5"
                    :searchQuery="searchQuery"
                    :makeSearch="makeSearch"
                    placeholder="Search courses..."
                ></LayoutSearchBar>
            </template>
        </SectionText>
        <div v-if="!searchQuery">
            <SectionCardsSwiper
                v-if="pathways && pathways.length"
                v-for="(pathway, index) in pathways"
                :contentful="index < 2"
                :id="'swiper-' + pathway.pathway_slug"
                :key="pathway.id_pathway"
                color="odd:bg-zinc-50 even:bg-zinc-100"
                :heading="pathway.pathway_name"
                :badgeText="pathway?.pathway_slug === 'intermediate-acoustic' ? 'New!' : null"
                :badgeColor="pathway?.pathway_slug === 'intermediate-acoustic' ? 'bg-green-600 text-white' : null"
                heading-component="h2"
                :cards="pathway.pathway_courses.map((course) => {
                    return {
                        route: useContextCourse().route(course, pathway.pathway_slug),
                        image: course.course_thumb_url,
                        imageAlt: 'The main image from this music course',
                        imageAspectRatio: 'aspect-[40/21]',
                        heading: course.course_title,
                        headingComponent: 'p',
                    };
                })"
            ></SectionCardsSwiper>
            <LayoutContained>
                <LoadingDetails
                    class="mt-5"
                    :error="error"
                    :entity="pathways"
                ></LoadingDetails>
            </LayoutContained>
        </div>
        <div v-else>
            <SectionCards
                v-if="courses?.length"
                color="bg-zinc-50"
                :excerptOnlyOnHover="true"
                :useHover="true"
                :cards="courses?.map((course) => {
                    return {
                        route: {
                            name: 'courses-courseSlug',
                            params: {
                                courseSlug: course.course_slug,
                            },
                        },
                        image: course.course_thumb_url,
                        imageAlt: 'The main image from this music course',
                        imageAspectRatio: 'aspect-[40/21]',
                        heading: course.course_title,
                        excerpt: course.course_excerpt,
                        buttonText: 'Learn More'
                    };
                })"
            ></SectionCards>
            <SectionLoadingList thing="courses" :results="courses" padding="py-10" :error="coursesError"></SectionLoadingList>
        </div>
    </Sections>
</template>

<script setup>
const {$config} = useNuxtApp();
useSeo().buildHead({
    title: 'Courses | ' + $config.public.siteName,
    description: 'Browse courses on the Andy Guitar website.',
    index: true,
});

await useLazyAsyncData('load', () => useStorePathways().getPathways().then(() => true));
</script>

<script>
import { mapState, mapActions } from 'pinia';

export default {
    computed: {
        ...mapState(useStorePathways, {
            pathways: 'pathways',
            error: 'error',
        }),
        ...mapState(useStoreCourses, {
            courses: 'courses',
            coursesError: 'error',
            searchQuery: 'searchQuery',
        }),
    },
    methods: {
        ...mapActions(useStoreCourses, {
            makeSearch: 'makeSearch',
        }),
    },
};
</script>
